import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ThemeProvider } from './components/common/ThemeProvider'
import { Layout } from './components/layout/Layout'
import { AppRouter } from './router'
import { AdminAuthProvider } from './contexts/AdminAuthContext'
import { ConditionalAnalytics } from './components/common/ConditionalAnalytics'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Layout>
              <AppRouter />
            </Layout>
          </BrowserRouter>
        </AdminAuthProvider>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <ConditionalAnalytics />
    </QueryClientProvider>
  )
}

export default App